import { render, staticRenderFns } from "./Diets.vue?vue&type=template&id=86440540&lang=pug&"
import script from "./Diets.vue?vue&type=script&lang=js&"
export * from "./Diets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports